var map = {
	"./1.png": "ef02",
	"./2.png": "d155",
	"./3.png": "6841",
	"./4.png": "0c14",
	"./5.png": "a13e",
	"./6.png": "210f",
	"./7.png": "3c65",
	"./8.png": "18b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e132";